import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { IConfig } from '@cian/config/shared';
import { ITelemetryLogger } from '@cian/telemetry/shared';

import * as React from 'react';

import { withProvider } from '../../redux';
import { IOfferHomeowner } from '../../redux/reducers';

import { ApplicationContext } from '../ApplicationContext';

import { CommercialOwnerWidgetLayout } from './components/CommercialOwnerWidgetLayout';

import { CommercialOwnershipWidget as Component } from './CommercialOwnershipWidget';

interface ICommercialOwnershipWidgetProps {
  httpApi: IHttpApi;
  logger: ILogger;
  config: IConfig;
  telemetry: ITelemetryLogger;
  onChange(homeOwner: IOfferHomeowner): void;
  onClear(): void;
}

export const CommercialOwnershipWidget = withProvider(
  ({ httpApi, logger, config, telemetry, ...props }: ICommercialOwnershipWidgetProps) => {
    const context = React.useMemo(() => ({ httpApi, logger, config, telemetry }), [httpApi, logger, config, telemetry]);

    return (
      <ApplicationContext.Provider value={context}>
        <CommercialOwnerWidgetLayout>
          <Component {...props} />
        </CommercialOwnerWidgetLayout>
      </ApplicationContext.Provider>
    );
  },
);
